'use client'

import * as echarts from 'echarts/core'
import { useCallback, useEffect, useRef } from 'react'

export default function Charts({
  options,
  modules
}) {

  useEffect(() => {
    if (modules) echarts.use(modules)
  }, [modules])

  const containerRef = useRef(null)
  const initCharts = useCallback(() => {
    const chart = echarts.init(containerRef.current)
    chart.setOption(options)

    return chart
  }, [containerRef, options])

  useEffect(() => {
    if (!containerRef.current) return

    const chart = initCharts()
    function resizeHandle () {
      chart.resize()
    }
    window.addEventListener('resize', resizeHandle)
    return () => {
      window.removeEventListener('resize', resizeHandle)
      chart.dispose()
    }
  }, [containerRef, options, initCharts])

  return (
    <div className='h-full' ref={containerRef}></div>
  )
}